'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createWidgetsManager;

var _utils = require('./utils');

function createWidgetsManager(onWidgetsUpdate) {
  var widgets = [];
  // Is an update scheduled?
  var scheduled = false;

  // The state manager's updates need to be batched since more than one
  // component can register or unregister widgets during the same tick.
  function scheduleUpdate() {
    if (scheduled) {
      return;
    }
    scheduled = true;
    (0, _utils.defer)(function () {
      scheduled = false;
      onWidgetsUpdate();
    });
  }

  return {
    registerWidget: function registerWidget(widget) {
      widgets.push(widget);
      scheduleUpdate();
      return function unregisterWidget() {
        widgets.splice(widgets.indexOf(widget), 1);
        scheduleUpdate();
      };
    },

    update: scheduleUpdate,
    getWidgets: function getWidgets() {
      return widgets;
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/core/createWidgetsManager.js
// module id = 1291
// module chunks = 142807904292071